import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getUsersSaga(action: types.GetUsersActionType) {
  try {
    const response = yield call(services.getUsersService);
    yield put({ type: actions.GET_USERS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_USERS_ERROR, response: error });
  }
}

export function* addUserSaga(action: types.AddUserActionType) {
  try {
    toastr.info("Creating User", `This may take a couple of seconds...`);
    const addResponse = yield call(services.addUserService, action.payload);
    const getResponse = yield call(services.getUsersService);
    if (addResponse.data) {
      yield put({ type: actions.ADD_USER_SUCCESS, response: addResponse });
      yield put({ type: actions.GET_USERS_SUCCESS, response: getResponse });
      toastr.success("User Created", `Added '${action.payload.body.username}'`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_USER_ERROR, response: error });
    toastr.error("User Not Created", `${error.error.message}`);
  }
}

export function* modifyUserSaga(action: types.ModifyUserActionType) {
  try {
    const modifyResponse = yield call(
      services.modifyUserService,
      action.payload
    );
    const getResponse = yield call(services.getUsersService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_USER_SUCCESS,
        response: modifyResponse,
      });
      yield put({ type: actions.GET_USERS_SUCCESS, response: getResponse });
      toastr.success(
        "User Modified",
        `Modified '${action.payload.body.username}'`
      );
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({ type: actions.MODIFY_USER_ERROR, response: error });
    toastr.error("User Not Modified", `${error.error.message}`);
  }
}

export function* deleteUserSaga(action: types.DeleteUserActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteUserService,
      action.payload
    );
    const getResponse = yield call(services.getUsersService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_USER_SUCCESS,
        response: deleteResponse,
      });
      yield put({ type: actions.GET_USERS_SUCCESS, response: getResponse });
      toastr.success("User Deleted", `Sad to see them go!`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_USER_ERROR, response: error });
    toastr.error("User Not Deleted", `${error.error.message}`);
  }
}

export function* getCurrentUserSaga(action: types.GetCurrentUserActionType) {
  try {
    const response = yield call(services.getCurrentUserService);
    yield put({ type: actions.GET_CURRENT_USER_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_CURRENT_USER_ERROR, response: error });
  }
}

export function* changePasswordCurrentUserSaga(
  action: types.ChangePasswordCurrentUserActionType
) {
  try {
    const response = yield call(
      services.changePasswordCurrentUserService,
      action.payload
    );
    if (response.data) {
      yield put({
        type: actions.CHANGE_PASSWORD_CURRENT_USER_SUCCESS,
        response,
      });
      console.log("YEET: " + JSON.stringify(response));
      toastr.success("Password Changed", `Success`);
    } else {
      throw response;
    }
  } catch (error) {
    yield put({
      type: actions.CHANGE_PASSWORD_CURRENT_USER_ERROR,
      response: error,
    });
    toastr.error("Password Not Changed", `${error.error.message}`);
  }
}
